import {
    initJump,
    // jump,
    // LazyLoad,
    SmoothScroll,
    // post,
    // postFormData,
    // youtubeVideo,
    // createUniqueHash,
    // addIntersectionItem,
    // setCookie,
    // getCookie,
    // isScrollingDown,
    waitAnimationFrame,
    // easeInOutQuad,
    // easeOutQuad,
    // animationEnd,
    // transitionEnd,
    ProgressiveHover,
    setViewUnits
} from './02-tools'
import { ScrollAnim, ReadMore, SetupTabs } from './06-utilities'
import {
    Selects, // dynamic import
    // FormInit, // dynamic import
    HoverLabelInit, // dynamic import
    SearchInputInit, // dynamic import
    AccordionsInit, // dynamic import
    // modalController,
    Modals,
    SliderInit, // dynamic import,
    PaletteBuilderInit, // dynamic import,
    // HoverItems,
    Header,
    setupProductRecommend,
    CountdownTimer,
    reviewHoverLabels,
    CurrencySelector,
    AlertBanner,
    AddToCartBtn,
    BundleSearch
} from './07-components'

// import { listen } from 'quicklink'
import lazySizes from 'lazysizes'
import 'wicg-inert'

init()

function init() {
    if (window.hasRun) {
        return
    }

    window.hasRun = true

    document.body.classList.remove('preload')
    document.body.classList.add('loaded') // trigger css to know js has loaded
    setViewUnits()

    // wait for style update from .loaded class
    waitAnimationFrame(2).then(() => {
        AccordionsInit()
        initJump()
        sliders()
        Modals()
        Header()
        HoverLabelInit()
        SearchInputInit()
        Selects()
        // Map()
        ScrollAnim(['.u-scroll-anim'])
        SmoothScroll()
        ReadMore()
        // HoverItems()
        ProgressiveHover()
        PaletteBuilderInit()
        SetupTabs()
        setupProductRecommend()
        CountdownTimer()
        reviewHoverLabels()
        CurrencySelector()
        AlertBanner()
        AddToCartBtn()
        BundleSearch()

        // if (!window.isLoggedIn) {
        //     listen()
        // }
        if (typeof lazySizes === 'function') {
            lazySizes()
        }
    })
}

function sliders() {
    SliderInit()
    shortProductListingSliderInit()
    categoriesSignpostSliderInit()
}

function shortProductListingSliderInit() {
    const sliderEls = document.querySelectorAll('.js-short-product-listing-slider')
    const sliders = Array.from(sliderEls)

    if (sliders.length) {
        import('./07-components/slider/slider')
            .then((m) => m.Slider)
            .then((Slider) => {
                sliders.forEach((el) => {
                    Slider(el, {
                        options: {
                            dots: true,
                            referenceDotContainer: true,
                            autoplay: false,
                            isInfinite: false,
                            horizontalSlide: true,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            disabled: true,
                            dotFormat: (x) => `<span>
                                    <span class="u-visually-hidden">slide ${x}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="163" height="190" viewBox="0 0 163 190">
                                        <path fill="currentColor" d="M149.8 84.3c1.8 1 4.7 2.3 8.6 3.8a7.3 7.3 0 0 1 4.6 7c0 3-1.8 5.7-4.6 6.8a82.8 82.8 0 0 0-8.6 3.8c-28.3 15.2-50.6 44-61.4 79a7.2 7.2 0 0 1-13.8 0c-10.8-35-33.1-63.8-61.4-79-1.9-1-4.7-2.3-8.6-3.8A7.3 7.3 0 0 1 0 95c0-3 1.8-5.8 4.6-6.9 3.9-1.5 6.8-2.8 8.6-3.8 28.3-15.2 50.6-44 61.4-79a7.2 7.2 0 0 1 13.8 0c10.8 35 33.1 63.8 61.4 79Z"/>
                                    </svg>
                                </span>`,
                            responsive: {
                                '768px': {
                                    slidesToShow: 4,
                                    isInfinite: true,
                                    autoplay: true,
                                    disabled: false
                                }
                            }
                        }
                    })
                })
            })
    }
}

function categoriesSignpostSliderInit() {
    const sliderEls = document.querySelectorAll('.js-category-signpost-slider')
    const sliders = Array.from(sliderEls)

    if (sliders.length) {
        import('./07-components/slider/slider')
            .then((m) => m.Slider)
            .then((Slider) => {
                sliders.forEach((el) => {
                    Slider(el, {
                        options: {
                            dots: true,
                            referenceDotContainer: true,
                            autoplay: false,
                            isInfinite: false,
                            horizontalSlide: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            disabled: true,
                            dotFormat: (x) => `<span>
                                    <span class="u-visually-hidden">slide ${x}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="163" height="190" viewBox="0 0 163 190">
                                        <path fill="currentColor" d="M149.8 84.3c1.8 1 4.7 2.3 8.6 3.8a7.3 7.3 0 0 1 4.6 7c0 3-1.8 5.7-4.6 6.8a82.8 82.8 0 0 0-8.6 3.8c-28.3 15.2-50.6 44-61.4 79a7.2 7.2 0 0 1-13.8 0c-10.8-35-33.1-63.8-61.4-79-1.9-1-4.7-2.3-8.6-3.8A7.3 7.3 0 0 1 0 95c0-3 1.8-5.8 4.6-6.9 3.9-1.5 6.8-2.8 8.6-3.8 28.3-15.2 50.6-44 61.4-79a7.2 7.2 0 0 1 13.8 0c10.8 35 33.1 63.8 61.4 79Z"/>
                                    </svg>
                                </span>`,
                            responsive: {
                                '768px': {
                                    slidesToShow: 2,
                                    isInfinite: true,
                                    disabled: false
                                }
                            }
                        }
                    })
                })
            })
    }
}
